import { useNavigate } from 'react-router';

import { BsCart2 } from "react-icons/bs";

import { useCart } from '../../hooks/useCart';

export const Header = () => {
  const navigate = useNavigate();
  const { count } = useCart();

  const handleRedirectTo = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(href);
  };

  return (
    <header className="z-full sticky top-0 left-0 flex items-center justify-between px-4 py-2 bg-red-600">
      <a href="#" onClick={handleRedirectTo('/')}>
        <img
          src="/assets/images/logo.svg"
          width="38px"
          height="38px"
          alt="Logo"
        />
      </a>

      <div className="relative">
        <a href="#" onClick={handleRedirectTo('/checkout')}>
          <BsCart2 className="text-4xl text-white" />
          <span className="w-5 h-5 flex items-center justify-center font-bold absolute -top-1 -right-1 bg-yellow-200 text-gray-600 text-xs rounded-full">
            {count}
          </span>
        </a>
      </div>
    </header>
  );
};
